import styled from 'styled-components';
import { variant } from 'styled-system';

const Button = styled('button')(
  {
    appearance: 'none',
    cursor: 'pointer',
    fontFamily: 'Overpass',
    outline: 'none',
    fontSize: '14px',
    lineHeight: '21px',
    border: 'none',
    borderRadius: '4px',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '36px',
    paddingRight: '36px',
    minHeight: '47px',
    fontWeight: 'bold',
    '&:disabled': {
      opacity: '0.5',
      cursor: 'not-allowed'
    }
  },
  variant({
    variants: {
      blue: {
        color: 'white',
        bg: '#3F76E6'
      },
      outline: {
        color: '#3F76E6',
        bg: 'white',
        border: '1px solid #3F76E6'
      },
      error: {
        color: 'white',
        bg: '#DA4C4C'
      },
      grey: {
        color: 'white',
        bg: '#918F8F'
      },
      green: {
        color: 'white',
        bg: '#327D30'
      },
      orange: {
        color: '#212121',
        bg: '#FB9700'
      }
    }
  })
);

export default Button;
